var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u952E\\u751F\\u6210\\u79FB\\u52A8\\u7AEF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6211\\u7684",
    transform: "translate(-325.000000, -191.000000)",
    fill: "#BBBBBB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "weixin-\\u5907\\u4EFD",
    transform: "translate(325.000000, 191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xiangyouxiayiye",
    transform: "translate(7.000000, 4.497500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89535729,6.32418222 C6.90335293,6.30871212 6.91628582,6.29577921 6.923294,6.27981537 C7.06052262,5.99429043 7.01559349,5.64497874 6.77259761,5.4153958 L1.26323767,0.20454854 C0.962818648,-0.0794540766 0.489211237,-0.0659451581 0.204701183,0.234021286 C-0.0792739993,0.534440311 -0.0662450968,1.00804772 0.234173929,1.29253036 L5.17748984,5.96886353 L0.253676131,10.7145516 C-0.0437805359,11.0015714 -0.0527636262,11.4751651 0.234173929,11.7730744 C0.380920494,11.9258417 0.577026036,12.0021499 0.77318642,12.0021499 C0.960295147,12.0021499 1.14748618,11.932315 1.29269671,11.7925766 L6.75209426,6.53082058 C6.76261339,6.52038375 6.76657691,6.50588737 6.77706861,6.49491567 C6.78506425,6.48738634 6.79352617,6.48190048 6.8015218,6.473946 C6.84395486,6.42948317 6.86641942,6.37510465 6.89535729,6.32418222 L6.89535729,6.32418222 Z",
    id: "\\u8DEF\\u5F84"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightNav);
export default __webpack_public_path__ + "static/media/right_nav.e69a2e9fd045efbd6c212b600dee28a1.svg";
export { ForwardRef as ReactComponent };